import { IPropWithClassNameChildren } from '@/types'
import clsx from 'clsx'

export const NswFilterList = ({
	className,
	children,
}: IPropWithClassNameChildren) => {
	return (
		<div className={clsx('nsw-filters__list', className)}>{children}</div>
	)
}
